module.exports = __webpack_public_path__ + "media/images/hero-b54764b5f04e59f6aaa3b8aba95aba5d.png";